import { Component, computed, input, Input, Signal } from '@angular/core';
import { CommonModule } from '@angular/common';

export type StageStatus = 'active' | 'disabled' | 'completed';

export interface ApplicationStage {
  name: string;
  status: StageStatus;
}

@Component({
  selector: 'app-stages',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './stages.component.html'
})
export class StagesComponent {

  @Input() currentStage: string = '';

  stages = input<string[]>([]);

  stageList: Signal<ApplicationStage[]> = computed<ApplicationStage[]>(() => {
    const current: number = this.stages().findIndex((v => v === this.currentStage));
    return this.stages().map((name, i) => {
      switch (true) {
        case current === i: {
          return {
            name,
            status: 'active'
          };
        }
        case i < current: {
          return {
            name,
            status: 'completed'
          };
        }
        default: {
          return {
            name,
            status: 'disabled'
          };
        }
      }
    });
  });

}
